import { IGoal } from "interfaces";
import { Apis, Constants, Enums, Helpers, Store } from "utils";

export interface IGoalService {
  all(): Promise<any>;
  // create(name: string): Promise<any>;
  // delete(id: number): Promise<any>;
  update(healthGoals: string[]): Promise<any>;
  remove(id: number, appointmentId: number): Promise<any>;
  add(id: number, appointmentId: number): Promise<any>;
}

export class GoalService implements IGoalService {
  private qubehub: any;
  private controllerName: string = "healthgoal";

  constructor(accessToken: string) {
    this.qubehub = Apis.qubehub(accessToken);
  }

  /**
   * fetch all the goals
   * @returns
   */

  async all() {
    try {
      return this.#handleResponse(await this.qubehub.get(this.controllerName));
    } catch (err: any) {
      console.log(err);
    }
    return [];
  }

  /**
   * create a new goal for the user
   * @param {string} name the title of the goal
   */

  // async create(title: string) {
  //   try {
  //     return this.#handleResponse(await this.qubehub.post(this.controllerName, { healthGoal: title }));
  //   } catch (err: any) {
  //     console.log(err);
  //   }
  //   return [];
  // }

  /**
   * delete the goal from the user
   * @param {number} id health goal id
   */

  // async delete(id: number) {
  //   try {
  //     return this.#handleResponse(await this.qubehub.delete(this.controllerName + "/" + id));
  //   } catch (err: any) {
  //     console.log(err);
  //   }
  //   return [];
  // }

  async update(healthGoals: string[]) {
    try {
      return this.#handleResponse(await this.qubehub.post(this.controllerName + "/update", { healthGoals: JSON.stringify(healthGoals) }));
    } catch (err: any) {
      console.log(err);
    }
    return [];
  }

  /**
   * add a new goal for the appointment
   * @param {number} id health goal id
   * @param {number} appointmentId appointment id
   */

  async add(id: number, appointmentId: number) {
    try {
      return this.#handleResponse(
        await this.qubehub.post(Helpers.interpolateURL(this.controllerName + "/:healthGoalId/appointment/:appointmentId", { healthGoalId: id, appointmentId: appointmentId }))
      );
    } catch (err: any) {
      console.log(err);
    }
    return null;
  }

  /**
   * remove the goal from the appointment
   * @param {number} id health goal id
   * @param {number} appointmentId appointment id
   */

  async remove(id: number, appointmentId: number) {
    try {
      return this.#handleResponse(
        await this.qubehub.delete(Helpers.interpolateURL(this.controllerName + "/:healthGoalId/appointment/:appointmentId", { healthGoalId: id, appointmentId: appointmentId }))
      );
    } catch (err: any) {
      console.log(err);
    }
    return null;
  }

  /**
   * method to handle the response from the API
   * @param {any} response the data retrieved from the API
   * @returns
   */

  #handleResponse(response: any) {
    if (response && response.data) {
      const { status, payload } = response.data;
      if (Enums.EnumResponse.Unauthorized === status) Store.sessionStorage.clear();
      return payload ? [status, payload] : [status, null];
    }
    return [Enums.EnumResponse.None, null];
  }
}

export default GoalService;
